import DataGrid2 from '../../..';
import { IControlProperties } from '../../../../../../../entities';
import { IDataGridColumn } from '../../../entities';

export function addColumns(this: DataGrid2, columns: IDataGridColumn<IControlProperties>[]) {
	const currentColumns = this.columns.map(c => c.name);

	if (columns.find(c => currentColumns.includes(c.name))) {
		console.error('DataGrid.addColumns : duplicate column error');
	} else {
		this.__proxyChanging.columns = [...this.columns, ...columns];
	}
}
